import {
  LOAD_SESSION_REPORTS,
  STORE_SESSION_REPORTS,
  CLEAR_SESSION_REPORTS,
  SESSION_REPORTS_FAILED,
  EDIT_BONUS_V2,
  DELETE_BONUS_V2,
  ADD_BONUS_V2,
  SUBMIT_BONUS_DECISION,
  EDIT_RAFFLE_V2,
  DELETE_RAFFLE_V2,
  SUBMIT_RAFFLE_DECISION,
  SUBMIT_POINT_DECISION,
  EDIT_TICKETOUT_V2,
  DELETE_TICKETOUT_V2,
  EDIT_TRANSACTION_V2,
  DELETE_TRANSACTION_V2,
  ADD_TRANSACTION_V2,
  EDIT_CASH_LEFT_V2,
  LOAD_AUDIT_LOG,
  STORE_AUDIT_LOG,
  LOAD_OWNER_AUDIT_SETTINGS,
  STORE_OWNER_AUDIT_SETTINGS,
  SAVE_OWNER_AUDIT_SETTINGS,
  LOAD_DUPLICATE_SCORES,
  STORE_DUPLICATE_SCORES,
  RECORD_LOCAL_DECISION,
  CLEAR_LOCAL_DECISIONS,
} from '../../constants/employeeSessionV2';

export const loadSessionReports = (data) => ({
  type: LOAD_SESSION_REPORTS,
  data,
});
export const storeSessionReports = (data) => ({
  type: STORE_SESSION_REPORTS,
  data,
});
export const clearSessionReports = () => ({ type: CLEAR_SESSION_REPORTS });
export const sessionReportsFailed = () => ({ type: SESSION_REPORTS_FAILED });

export const editBonusV2 = (data, callback) => ({
  type: EDIT_BONUS_V2,
  data,
  callback,
});
export const deleteBonusV2 = (data, callback) => ({
  type: DELETE_BONUS_V2,
  data,
  callback,
});
export const addBonusV2 = (data, callback) => ({
  type: ADD_BONUS_V2,
  data,
  callback,
});
export const submitBonusDecision = (data, callback) => ({
  type: SUBMIT_BONUS_DECISION,
  data,
  callback,
});

export const editRaffleV2 = (data, callback) => ({
  type: EDIT_RAFFLE_V2,
  data,
  callback,
});
export const deleteRaffleV2 = (data, callback) => ({
  type: DELETE_RAFFLE_V2,
  data,
  callback,
});
export const submitRaffleDecision = (data, callback) => ({
  type: SUBMIT_RAFFLE_DECISION,
  data,
  callback,
});

export const submitPointDecision = (data, callback) => ({
  type: SUBMIT_POINT_DECISION,
  data,
  callback,
});

export const editTicketOutV2 = (data, callback) => ({
  type: EDIT_TICKETOUT_V2,
  data,
  callback,
});
export const deleteTicketOutV2 = (data, callback) => ({
  type: DELETE_TICKETOUT_V2,
  data,
  callback,
});

export const editTransactionV2 = (data, callback) => ({
  type: EDIT_TRANSACTION_V2,
  data,
  callback,
});
export const deleteTransactionV2 = (data, callback) => ({
  type: DELETE_TRANSACTION_V2,
  data,
  callback,
});
export const addTransactionV2 = (data, callback) => ({
  type: ADD_TRANSACTION_V2,
  data,
  callback,
});

export const editCashLeftV2 = (data, callback) => ({
  type: EDIT_CASH_LEFT_V2,
  data,
  callback,
});

export const loadAuditLog = (data) => ({ type: LOAD_AUDIT_LOG, data });
export const storeAuditLog = (logs) => ({ type: STORE_AUDIT_LOG, logs });

export const loadOwnerAuditSettings = (data) => ({
  type: LOAD_OWNER_AUDIT_SETTINGS,
  data,
});
export const storeOwnerAuditSettings = (settings) => ({
  type: STORE_OWNER_AUDIT_SETTINGS,
  settings,
});
export const saveOwnerAuditSettings = (data, callback) => ({
  type: SAVE_OWNER_AUDIT_SETTINGS,
  data,
  callback,
});

export const loadDuplicateScores = (data) => ({
  type: LOAD_DUPLICATE_SCORES,
  data,
});
export const storeDuplicateScores = (scores) => ({
  type: STORE_DUPLICATE_SCORES,
  scores,
});

export const recordLocalDecision = (entityType, entityId, decision) => ({
  type: RECORD_LOCAL_DECISION,
  entityType,
  entityId,
  decision,
});
export const clearLocalDecisions = () => ({ type: CLEAR_LOCAL_DECISIONS });
